export default "__VITE_ASSET__CVbpTJXm__"